import type { UndefinedOnPartialDeep } from 'type-fest';

import Accordion, { AccordionItem } from '@ingka/accordion';
import Image from '@ingka/image';
import ProductIdentifier from '@ingka/product-identifier';
import { translate } from '@repo/phrase';
import type { Service } from '@repo/types/service';
import { Heading, Paragraph } from '@repo/ui/typography';

import { getArticleNo } from '@/utils/article.utils';

import parentStyles from '../styles.module.scss';
import styles from './styles.module.scss';

interface Props {
    referenceItems: UndefinedOnPartialDeep<Service['referenceItems']> | undefined;
}

export const ArticleDetailsView = ({ referenceItems }: Props) => {
    if (!referenceItems || !Array.isArray(referenceItems) || referenceItems.length === 0) {
        return;
    }

    return (
        <Accordion data-testid="article-list-accordion">
            <AccordionItem
                id="article-list-accordion"
                data-testid="article-list-accordion-item"
                title={translate('article_title_item', {
                    number: referenceItems.length.toString(),
                })}
                subtle={true}
                className={`${parentStyles.article_list_accordion_item}`}
            >
                {referenceItems.map((item) => {
                    const { retailItemName, itemId, quantity, image, retailItemDescription } = item;
                    const title = translate('services_article_list_modal_product_title', {
                        quantity: quantity?.toFixed(0) ?? '',
                        name: retailItemName ?? '',
                    });
                    return (
                        <div
                            data-testid="article-list-accordion-item-description"
                            className={`${parentStyles.article_list_container} ${styles.article_details_container}`}
                            key={item.itemId}
                        >
                            {image && <Image src={image} alt={retailItemName ?? ''} />}
                            <div className={styles.article_details_description}>
                                <Heading headingSize="xs">{title}</Heading>
                                <Paragraph>{retailItemDescription}</Paragraph>
                                {itemId && <ProductIdentifier subtle={true} value={getArticleNo(itemId)} />}
                            </div>
                        </div>
                    );
                })}
            </AccordionItem>
        </Accordion>
    );
};
